import { PROPERTY_DATA_FILTER_KEYS } from '@/constants';
import { StyledTag } from './map-siderbar-styles';

// just map names of sections we need
const sectionKVs = {
  residentialType: 'Residential Type',
  addressIdentification: 'Address Identification',
  locationType: 'Property Location',
  unitType: 'Unit Type',
  rentalStructure: 'Rental Structure',
  onlinePlatforms: 'Online Platform',
  occupancy: 'Occupancy',
  rentalType: 'Rental Type',
  strLicense: 'STR License',
  activity: 'Activity',
  verification: 'Verification',
  [PROPERTY_DATA_FILTER_KEYS.complaints]: 'Complaints',
  [PROPERTY_DATA_FILTER_KEYS.violations]: 'Violations',
  [PROPERTY_DATA_FILTER_KEYS.hoe]: 'Homeowner Exemption',
};

const sectionNames = Object.keys(sectionKVs);

export function MapFilterParamTags({
  mapFilterParams,
  handleCheckboxOnChange,
  filterSectionTagsMap,
}) {
  /** Attention: filterParams is an immutable js data structure, Map
   * filter api: filter(
   *   predicate: (value: V, key: K, iter: this) => any, context?: any
   * ): this
   * map api: map<M>(
   *   mapper: (value: V, key: K, iter: this) => M, context ?: any
   * ): Collection < K, M >
   */
  const filterParams = mapFilterParams
    // keep the sections we need, and filter out those we don't need
    .filter((_, sectionName) => sectionNames.includes(sectionName))
    // get a new filterParams object, just keep section items with true-y values
    // i.e., all checked checkboxes
    .map((sectionItems) =>
      sectionItems.filter((sectionItemValue) => sectionItemValue)
    );

  const filterParamsObj = filterParams.toJS();
  // generate tag components for all selected/checked checkboxes
  return (
    <>
      {Object.entries(filterParamsObj).flatMap(
        ([sectionName, sectionItems]) => {
          const userFriendlySectionName = sectionKVs[sectionName];
          // filter all the selected filters (values of which are true)
          const sectionItemNames = Object.keys(sectionItems).filter(
            (itemName) => sectionItems[itemName]
          );

          return sectionItemNames.map((sectionItemName) => {
            let displayedTagContent;
            let sectionItemValue = false;
            if (sectionItemName === 'numberValue') {
              displayedTagContent = `${userFriendlySectionName} - ${filterParamsObj.occupancy.numberValue}%`;
              sectionItemValue = 0;
            } else {
              displayedTagContent =
                filterSectionTagsMap[sectionName][sectionItemName];
            }

            if (!displayedTagContent) return <></>;

            return (
              <StyledTag
                key={displayedTagContent}
                closable
                onClose={() =>
                  handleCheckboxOnChange(
                    sectionName,
                    sectionItemName,
                    sectionItemValue
                  )
                }
              >
                {displayedTagContent}
              </StyledTag>
            );
          });
        }
      )}
    </>
  );
}
